import React from "react";
import Login from "./pages/login/login.js"
import Application from "./application.js"
import {BrowserRouter as Router, Route, Switch, Redirect} from "react-router-dom"
import PrivateRoute from "./_helpers/privateRoute.js"

function Error(){
  return(
      <h1>404, Not Found</h1>
  )
}

class Main extends React.Component {
    
    componentDidMount = () => {
        document.title = "Advertaze Campaign Manager";    
    };

  render() {
    return (
      <div>
          <Router>
            <Switch>
                <Route path="/login/" component={Login} />
                <PrivateRoute component={Application} />
                <PrivateRoute path="/*" component={Application} />
                <Route component={Error}/> {/* handles urls with no match */}
            </Switch>
          </Router>
      </div>
    );
  }
}

export default Main;
